export enum ServerStatus {
    Loading = 1337,
    PreInstall = 0,
    Install = 1,
    Suspended = 2,
    Stopped = 3,
    Stopping = 4,
    Starting = 5,
    Running = 6,
    Updating = 7,
    Removing = 98,
    Maintenance = 99,
    Unknown = 100,
}

export enum PageType {
    Order = 'order',
    Unknown = 'unknown',
    Customers = 'customer',
    Game = 'game',
    Voice = 'voice',
    Payment = 'payment',
    PaymentOverview = 'payment_overview',
    LandingPage = 'landingpage',
    GameCloud = 'gamecloud'
}

export interface ServerState {
    _stateId: number;
    _stateName: ServerStatus;
}

export enum ServerAction {
    Start = 'start',
    Stop = 'stop',
    Restart = 'restart',
    Delete = 'delete',
    Settings = 'settings',
    Reinstall = 'reinstall'
}

export interface IStartGameserverResponse {
    message: string;
    result: boolean;
}

export interface IGameserverSettingsLinks {
    settings: string;
    delete: string;
    start: string;
    stop: string;
    restart: string;
}

export interface IGamecloudEditorData {
    openEventName: string;
    closeEventName: string;
    slots: number;
    orderId: string;
}

export interface IGetForEdit {
    durationId: string;
    durations: [any];
    orderId: string;
    slotSteps: [number];
    slots: string;
    slotRange: [any];
}

export interface IPricing {
    currentPrice: number;
    currentPriceFormatted: string;
    newPrice: number;
    newPriceFormatted: string;
    remainingDays: number;
    totalSum: number;
    totalSumFormatted: string;
    updateNow: boolean;
    voucherPrice: number;
    voucherPriceFormatted: string;
}

export interface ISocketData {
    cpu: number;
    cpuTotal: number;
    ioReadBytes: number;
    ioReads: number;
    ioWriteBytes: number;
    ioWrites: number;
    memory: {
        percent: number;
        total: number;
        used: number;
    };
    started: number;
}

export interface ICreateBackupResponse {
    result: boolean;
    message: string;
}

export interface IDonate {
    amount: number;
    balance: number;
    customer_id: number;
    remains: number;
}

export interface IHardDiskStatus {
    MBSize: number;
    ModSpace: string;
    state: boolean;
    totalSpace: number;
    unit: string;
    usedPercentage: number;
    usedSpace: number;
    usedSpaceUnite: string;
}

export interface IGameCloudEditorPostData {
    slots: any;
    duration: any;
    gameCloudOrderId: any;
}

export interface IActivateCheck {
    check: boolean;
    price: number;
    currency: string;
}

export interface IMapItemData {
    name: string;
    rounds?: string;
    type?: string;
    index?: number;
    counter?: number;
    label?: string;
    typeLabel?: string;
    image?: string;
}

export interface IMapGroupResponse {
    imageData: string[];
    mapGroups: any;
    mapLists: IMap[];
    wsIds: string[];
}

export interface IMap {
    id: string;
    img: string;
    label: string;
}

export interface IMapData extends IMapGroupResponse {
    mapCycle: string[],
    maps: [{
        id: string;
        label: string;
        img: string;
    }]
}

export interface IServerQueryResponse {
    online: boolean;
    name?: string;
    ipAddress?: string;
    port?: number;
    maxPlayers: number;
    currentPlayers: number;
    key?: string;
    queried?: string;
    extraPorts?: string;
    serverId?: string;
}
